import React from "react";

import { Grid } from "@mui/material";

import useStyles from "./styles";

interface DetailsSectionTitleProps {
  title: string;
}

export const DetailsSectionTitle = ({ title }: DetailsSectionTitleProps) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} className={classes.title}>
      <span className={classes.title}>{title}</span>
    </Grid>
  );
};
